document.addEventListener( 'DOMContentLoaded', function() {
  if (!document.querySelector('#slider-section__slider').classList.contains('is-splide')) {
    const sliderSection = new Splide('#slider-section__slider', {
      type: 'slide',
      perPage: 4,
      gap: 40,
      autoplay: true,
      rewind: true,
      classes: {
        arrows: 'splide__arrows slider-section__arrows',
        arrow: 'splide__arrow slider-section__arrow',
        prev: 'splide__arrow--prev slider-section__arrowPrev',
        next: 'splide__arrow--next slider-section__arrowNext',
        pagination: 'splide__pagination slider-section__pagination',
        page: 'splide__pagination__page slider-section__page',
      },
      breakpoints: {
        991: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        576: {
          perPage: 1,
        }
      }
    });
    sliderSection.mount();
  }
});
